import { makeStateStore } from '@playcastdotio/StateStore';

type AuthState = {
  jwtToken: string;
};

export const authStore = makeStateStore<AuthState>({
  jwtToken: '',
});
